import React, { memo } from 'react';
export const ModulesSection = () => {
  const modules = [{
    num: '1',
    icon: '🧠',
    title: 'Cuaderno Mente Despierta',
    subtitle: 'Estimulación cognitiva · Letra grande',
    desc: 'Actividades de memoria, atención, lenguaje y cálculo para acompañar al adulto mayor sin complicaciones.',
    includes: ['Actividades cognitivas en letra grande', 'Instrucciones claras para el cuidador', 'Espacio de respuesta', 'Seguimiento mensual']
  }, {
    num: '2',
    icon: '🦵',
    title: 'Movilidad Sin Miedo',
    subtitle: 'Ejercicios en silla y de pie',
    desc: 'Rutinas suaves de movilidad, equilibrio y fuerza con apoyo, explicadas con ilustraciones simples.',
    includes: ['Rutinas en silla', 'Ejercicios de equilibrio y fuerza', 'Ilustraciones claras', 'Señales para detener y consultar']
  }, {
    num: '3',
    icon: '🏥',
    title: 'Cuidado Experto',
    subtitle: 'Alzheimer · Parkinson · Diabetes · Hipertensión',
    desc: 'Orientación práctica para organizar el acompañamiento diario ante condiciones frecuentes.',
    includes: ['Pautas de acompañamiento', 'Organización de controles', 'Señales de alarma', 'Espacio para registrar información']
  }, {
    num: '4',
    icon: '📋',
    title: 'Bitácora de Control 360',
    subtitle: 'Medicación · Presión · Glucemia · Sueño',
    desc: 'Planillas para ordenar información de salud y llevar un mejor registro diario.',
    includes: ['Registro de medicación', 'Presión y glucemia', 'Ánimo y sueño', 'Consultas y estudios']
  }, {
    num: '5',
    icon: '⭐',
    title: 'Guía del Cuidador',
    subtitle: 'Organización · Límites · Autocuidado',
    desc: 'Herramientas para organizar el cuidado, repartir responsabilidades y prevenir el agotamiento.',
    includes: ['Organización diaria', 'Mapa familiar del cuidado', 'Autocuidado del cuidador', 'Ideas para pedir ayuda']
  }];
  const inclusions = ['Letra grande', 'Ilustraciones claras', 'Instrucciones simples', 'Material imprimible'];
  return <section id="modulos" className="bg-familia-card py-10 md:py-16 px-4 md:px-6" data-id="element-135">
      <div className="max-w-7xl mx-auto w-[92%] md:w-full" data-id="element-136">
        <div className="text-center mb-10 md:mb-16" data-id="element-137">
          <h2 className="text-[22px] sm:text-3xl md:text-5xl font-display font-bold mb-4 md:mb-6" data-id="element-138">
            📚 LOS 5 MÓDULOS CENTRALES — <br className="hidden sm:block" data-id="element-139" /> Para
            el cuidado integral del adulto mayor
          </h2>
          <p className="text-familia-gray text-[15px] md:text-lg max-w-3xl mx-auto leading-relaxed" data-id="element-140">
            Cada módulo combina actividades para el adulto mayor, guía para el
            cuidador o familiar, registros de salud e instrucciones claras en
            cada página.
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 md:gap-6 mb-10 md:mb-16" data-id="element-141">
          {modules.map((m, i) => <div key={i} className="bg-familia-section border border-familia-cyan/25 p-6 md:p-8 rounded-2xl card-hover flex flex-col" data-id="element-142">
              <div className="flex items-center justify-between mb-4" data-id="element-143">
                <span className="text-familia-cyan font-mono font-bold text-xs sm:text-sm" data-id="element-144">
                  MÓDULO {m.num}
                </span>
                <span className="text-3xl md:text-4xl" data-id="element-145">{m.icon}</span>
              </div>
              <h3 className="text-lg md:text-xl font-display font-bold mb-1" data-id="element-146">
                {m.title}
              </h3>
              <p className="text-familia-gold text-xs sm:text-sm font-semibold mb-4" data-id="element-147">
                {m.subtitle}
              </p>
              <p className="text-familia-gray text-[14px] md:text-sm leading-relaxed mb-6" data-id="element-148">
                {m.desc}
              </p>
              <div className="border-t border-white/10 pt-4 mt-auto" data-id="element-149">
                <p className="text-xs font-bold text-white/90 uppercase tracking-wider mb-3" data-id="element-150">
                  Incluye:
                </p>
                <ul className="space-y-2" data-id="element-151">
                  {m.includes.map((item, j) => <li key={j} className="flex items-start gap-2 text-[13px] text-familia-gray" data-id="element-152">
                      <span className="text-familia-cyan shrink-0" data-id="element-153">→</span>
                      <span data-id="element-154">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>)}
        </div>
        <div className="bg-familia-bg border border-familia-cyan/30 border-dashed p-6 md:p-12 rounded-3xl max-w-4xl mx-auto" data-id="element-155">
          <h4 className="text-lg md:text-xl font-display font-bold mb-6 md:mb-8 text-center" data-id="element-156">
            Cada módulo incluye:
          </h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 md:gap-x-12 gap-y-3 md:gap-y-4" data-id="element-157">
            {inclusions.map((item, i) => <div key={i} className="flex items-center gap-3 md:gap-4" data-id="element-158">
                <span className="text-familia-green text-lg md:text-xl" data-id="element-159">
                  ✅
                </span>
                <span className="text-[14px] sm:text-base font-medium" data-id="element-160">
                  {item}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};